import React, { useEffect, useState,useCallback, useRef  } from "react";
import { SearchInput, SidebarDrawer } from "../../common";
import { AddSquareIcon, CloseIcon, SearchIcon } from "../../../assets/icons";
import { CreateUser } from "./create/CreateUser";
import { EditUser } from "./edit/EditUser";
import { DisablePrompt } from "./DisablePrompt";
import { DeleteUser } from "./DeleteUser";
import { UsersTable } from "./list/UsersTable";
import { UserDetail } from "../../../types";
import { EnablePrompt } from "./EnablePrompt";
import { useSubUserStore } from "../../../state/useSubUserStore";
import ThreeDot from "../../../assets/icons/ThreeDot";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { checkSubscription } from "../../../utils/subscription";
import { servicesType } from "../../../constants/Subscription";
import { SubscriptionModal } from "../../common/Subscription/SubscriptionModal";
import { MobileSubscriptionModal } from "../../common/Subscription/MobileSubscriptionModal";
import DesktopSubscriptionModal from "../../common/Subscription/DesktopSubscriptionModal";
import DeleteUserIcon from "../../../assets/icons/deleteUser";
import { EnableUserIcon } from "../../../assets/icons/enableUser";
import EditUserIcon from "../../../assets/icons/editUser";
import RectangleModal from "../../common/rectangleModal";
import PlusSignIcon from "../../../assets/icons/PlussignIcon";
import { useUserSearch } from "../../../hooks/users/useUserSearch";
import { getRoleStyle } from "../../../utils/getRoleBadge";
import PageLoader from "../../common/PageLoader";
import UserEmptyIcon from "../../../assets/icons/UserEmptyIcon"

const UserManagement = () => {
  const { t } = useTranslation("user");
  const navigate = useNavigate();

  const [text, setText] = React.useState("");
  const [isSideBarOpen, setIsSidebarOpen] = React.useState<boolean>(false);
  const [isEdit, setIsEdit] = React.useState<boolean>(false);
  const [disable, setDisable] = React.useState<boolean>(false);
  const [enable, setEnable] = React.useState<boolean>(false);
  const [deleteUser, setDeleteUser] = React.useState<boolean>(false);
  const [userId, setUserId] = React.useState<string>("");
  const [openDotmenuId, setOpenDotmenuId] = useState<string | null>(null);
  const [openDotmenu, setOpenDotmenu] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] =
    React.useState(false);
  const [subscriptionErrorMessage, setSubscriptionErrorMessage] =
    React.useState<string>("");
  const isMobile = window.innerWidth < 768;
  const hasFetched = useRef(false);

  const handleUserClick = () => {
    const subscriptionCheck = checkSubscription(servicesType.Users);
    if (subscriptionCheck.status) {
      setIsSidebarOpen(true);
    } else {
      setIsSidebarOpen(false);
      setShowSubscriptionModal(true);
      setSubscriptionErrorMessage(subscriptionCheck.message || "");
    }
  };

  const handleDropdown = (id: string) => {
    setOpenDotmenu(true);
    setOpenDotmenuId(openDotmenuId === id ? null : id);
  };

  const handleEdit = (id: string) => {
    setOpenDotmenu(false);
    setIsEdit(true);
    setUserId(id);
  };

  const handleDisable = (id: string) => {
    setOpenDotmenu(false);
    setDisable(true);
    setUserId(id);
  };
  const handleEnable = (id: string) => {
    setOpenDotmenu(false);
    setEnable(true);
    setUserId(id);
  };

  const handleDelete = (id: string) => {
    setOpenDotmenu(false);
    setDeleteUser(true);
    setUserId(id);
  };

  const {
    fetchUsers,
    users: allUsers,
    fetchMoreData,
    pagination,
    isLoading,
  } = useSubUserStore((state) => ({
    fetchUsers: state.fetchUsers,
    fetchMoreData: state.fetchMoreData,
    users: state.users,
    pagination: state.pagination,
    isLoading: state.isLoading,
  }));

  useEffect(() => {
  if (!hasFetched.current) {
    fetchUsers();
    hasFetched.current = true;
  }
}, []);



  const {
    data: searchedUsers,
    isSearching,
    handleSearch: handleUserSearch,
  } = useUserSearch();

  if (isLoading) {
    return (
      <div>
        <PageLoader />
      </div>
    );
  }
  // Decide which users to display based on whether a search is active
  const displayedUsers = isSearching ? searchedUsers : allUsers;
  

  const userData = (users: UserDetail[]) => {
    return users?.map((user: any) => {
      return {
        id: user.id,
        user: `${user.firstname} ${user.lastname}`,
        email: user.email,
        role: (
          <span
            className={`px-2 py-1 text-[12px] lg:text-[14px] rounded font-medium ${getRoleStyle(
              user.role
            )}`}
          >
            {user.role}
          </span>
        ),
        userStatus: user.status,
        status: (
          <span
            className={`px-2 py-1 text-[12px] lg:text-[14px] rounded border border-gray-200 font-medium ${
              user.status === undefined || null
                ? "bg-[#B5CDB4] text-[#12B76A]"
                : user.status === "ENABLED"
                ? "text-[#088306]"
                : "text-[#FB0303]"
            }  `}
          >
            {user.status === undefined || null
              ? "Active"
              : user.status === "ENABLED"
              ? "Active"
              : "Disabled"}
          </span>
        ),
        action: (
          <div className="flex items-center justify-center">
            <div className="relative">
              <div
                className="cursor-pointer"
                onClick={() => handleDropdown(user.id)}
              >
                <ThreeDot />
              </div>
              {openDotmenu && openDotmenuId === user.id && (
                <div className="absolute z-20 shadow-lg rounded-md right-[-0em] md:right-[-2.5em] top-4 md:top-6 right- w-[180px] bg-white text-[11px] md:text-[14px] text-[#4E4E4E] ">
                  <div
                    className="flex justify-start pl-3 mb-2"
                    onClick={() => handleEdit(user.id)}
                  >
                    <span className="mt-[0.8em] pr-3">
                      <EditUserIcon />
                    </span>
                    <p
                      className="cursor-pointer lg:py-3 py-2 text-center text-[16px]"
                      onClick={() => handleEdit(user.id)}
                    >
                      Edit Users
                    </p>
                  </div>
                  {user.status === "ENABLED" && (
                    <div
                      className="flex items-center justify-start pl-3 cursor-pointer lg:py-3 pb-2 text-center border-[#A4A4A4] text-[16px]"
                      onClick={() => handleDisable(user.id)}
                    >
                      <EnableUserIcon />
                      <span className="ml-3">Disable</span>
                    </div>
                  )}
                  {user.status === "DISABLED" && (
                    <div
                      className="flex items-center justify-start pl-3 cursor-pointer lg:py-3 pb-2 text-center border-[#A4A4A4] text-[16px]"
                      onClick={() => handleEnable(user.id)}
                    >
                      <EnableUserIcon />
                      <span className="ml-3">Enable</span>
                    </div>
                  )}
                  <div
                    className="flex justify-start pl-3 mt-2"
                    onClick={() => handleDelete(user.id)}
                  >
                    <span className="lg:mt-[0.8em] mt-[0.2em] pr-3">
                      <DeleteUserIcon />
                    </span>
                    <p
                      className="cursor-pointer lg:py-3 pb-2 text-[#FB0303] text-center text-[16px]"
                      onClick={() => handleDelete(user.id)}
                    >
                      Delete
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ),
      };
    });
  };

  return (
    <>
      <div className=" mt-14 w-full h-screen lg:mt-[] md:border border-gray-300 rounded-lg bg-white">

        <div className="md:hidden justify-center items-center flex">
          <h1 className="text-[20px] font-semibold">User Management</h1>
        </div>
        
        <div className=" md:mx-0  md:flex  lg:flex justify-between items-center md:border-b  py-4 md:p-4">
          <div className="">
            <SearchInput
              dropdownWidth="w-full xl:w-[300px] lg:w-[290px]"
              placeholder="Search by user’s name"
              displayKey="name"
              icon={<SearchIcon />}
              isLoading={isSearching}
              value={text}
              clearIcon={CloseIcon}
              data={
                isSearching
                  ? displayedUsers.map((user) => ({
                      ...user,
                      name: `${user.firstname || user.firstName} ${
                        user.lastname || user.lastName
                      }`,
                    }))
                  : []
              }
              handleChangeText={handleUserSearch}
              searchKey={"name"}
              emptyMessage={"This Item is not found"}
              dropdownStyle={{
                maxHeight: "800px",
                overflowY: "auto",
              }}
              classNames="w-full block p-4 pl-10 xl:w-[300px] lg:w-[290px] md:mt-[0em] lg:ml-[0em] !xl:ml-[0em] border border-gray-300 bg-white  placeholder:text-[15.25px]  rounded-lg p-2 mt-[5px] focus:outline-none focus:shadow-outline appearance-none lg:focus:ring-0 leading-normal"
            />
          </div>
          <div
            onClick={handleUserClick}
            className=" hidden md:flex items-center text-[white] bg-[#044E97] gap-1 font-semibold text-[16px] rounded-[4px] border border-[#0A0A0A1A] px-[16.5px] h-[48px] cursor-pointer z-0 "
          >
            <PlusSignIcon />
            <p className="">{t("user.addNewUser")}</p>
          </div>
        </div>

        <div className="h-screen flex flex-col justify-between pb-[30px]  .scrollbar-hide ">
          <div className=" md:border-none rounded-md ">
          <div className="h-screen flex flex-col justify-between pb-[30px]">
  {displayedUsers.length > 0 ? (
    <div className="md:border-none rounded-md">
      <UsersTable
        handleDisable={handleDisable}
        handleEnable={handleEnable}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        data={userData(displayedUsers)}
        isLoading={isLoading}
        meta={pagination}
        fetchMoreData={fetchMoreData}
      />
    </div>
  ) : (
    <div className="flex flex-col items-center mt-10 lg:mt-24 h-full">
      <UserEmptyIcon />
      <p className="text-gray-800 font-semibold mt-4">No users yet</p>
      <button
        onClick={handleUserClick}
        className="mt-4 px-12 py-2 border border-[#044E97] text-[#044E97] font-semibold rounded-md"
      >
        Add users
      </button>
    </div>
  )}
</div>
          </div>

          <div className=" w-full pb-5">
              <button
            onClick={handleUserClick}
            className=" md:hidden flex items-center w-full text-[white] bg-[#044E97] gap-1 justify-center  font-semibold text-[16px] rounded-[4px] border border-[#0A0A0A1A] px-[16.5px] h-[48px] cursor-pointer z-0 "
          >
            {/* <PlusSignIcon /> */}
            <p className="">{t("user.addNewUser")}</p>
          </button>
          </div>
        </div>

        {disable && (
          <RectangleModal
            isOpen={disable}
            onCancel={() => setDisable(false)}
            title={"Disable User"}
          >
            <DisablePrompt userId={userId} setShowPrompt={setDisable} />
          </RectangleModal>
        )}
        {enable && (
          <RectangleModal
            isOpen={enable}
            onCancel={() => setEnable(false)}
            title={"Enable User"}
          >
            <EnablePrompt userId={userId} setShowPrompt={setEnable} />
          </RectangleModal>
        )}

        {deleteUser && (
          <RectangleModal
            isOpen={deleteUser}
            onCancel={() => setDeleteUser(false)}
            title={"Delete User"}
          >
            <DeleteUser userId={userId} setShowPrompt={setDeleteUser} />
          </RectangleModal>
        )}

        {isSideBarOpen && (
          <CreateUser
            onClose={() => setIsSidebarOpen(false)}
            show={isSideBarOpen}
          />
        )}

        {isEdit && (
          <EditUser
            userId={userId}
            onClose={() => setIsEdit(false)}
            show={isEdit}
          />
        )}
        <div className="mt-[-30em]">
          {showSubscriptionModal && (
            <SubscriptionModal>
              <MobileSubscriptionModal
                onClose={() => setShowSubscriptionModal(false)}
                titleText={`Need to access more features?`}
                subtitleText={subscriptionErrorMessage}
              />
            </SubscriptionModal>
          )}
        </div>
      </div>
    </>
  );
};

export default UserManagement;
